import { h } from 'preact';
import PureComponent from './PureComponent';
import { widont } from 'journalize';
import { PreactHTMLConverter } from 'preact-html-converter';

import PartyColumn from './PartyColumn';

// Internal
import data from '../../../data/data.json';
import note from '../../../data/ballot-note.json';
const tagsData = data.tags;
const candidatesData = data.candidates;
const notesData = note.notes.filter(note =>
  note.type.includes('texas-house-district')
);
notesData.forEach(note => {
  const district = note.type.match(/\d+/)[0];
  note.district = +district;
});

class DistrictViewer extends PureComponent {
  constructor() {
    super();

    this.state = {};
  }

  getRepUrl(name) {
    const slug = name.replaceAll(' ', '-').toLowerCase();
    const url = `https://www.texastribune.org/directory/${slug}`;

    return url;
  }

  convertPartyName(party) {
    return party == 'REP' ? 'Republican' : 'Democratic';
  }

  addArticles(tag) {
    let added;

    if (tag == 'uncontested') {
      added = (
        <span>
          an <strong class={tag}>{tag}</strong>
        </span>
      );
    } else {
      added = (
        <span>
          a <strong class={tag}>{tag}</strong>
        </span>
      );
    }

    return added;
  }

  get2024PrimarySummary(dp, rp) {
    const { district } = this.props;

    const ones = [
      '',
      'one',
      'two',
      'three',
      'four',
      'five',
      'six',
      'seven',
      'eight',
      'nine',
    ];

    const dSummary =
      dp == 0
        ? 'no candidates are running in the Democratic primary'
        : dp == 1
        ? `HD ${district} will have an uncontested Democratic primary`
        : `${ones[dp]} candidates are running in the Democratic primary`;

    const rSummary =
      rp == 0
        ? 'no candidates are running in the Republican primary'
        : rp == 1
        ? `HD ${district} will have an uncontested Republican primary`
        : `${ones[rp]} candidates are running in the Republican primary`;

    let summary;

    if (dp === 1 && rp === 1) {
      summary = `HD ${district} will have both uncontested Republican and Democratic primaries`;
    } else if (dp === 0 && rp === 1) {
      summary = `${rSummary} and ${dSummary}`;
    } else if (rp === 0 && dp === 1) {
      summary = `${dSummary} and ${rSummary}`;
    } else if (dp === 0 && rp > 1) {
      summary = `${rSummary} and ${dSummary} in HD ${district}`;
    } else if (rp === 0 && dp > 1) {
      summary = `${dSummary} and ${rSummary} in HD ${district}`;
    } else if (dp === 1 && rp > 1) {
      summary = `${dSummary} and ${rSummary}`;
    } else if (dp > 1 && rp === 1) {
      summary = `${rSummary} and ${dSummary}`;
    } else {
      summary = `${dSummary} and ${rSummary} in HD ${district}`;
    }

    return summary;
  }

  getMatch() {
    const { district } = this.props;
    const candidates = candidatesData.filter(d => d.district === district);
    const partyBallot = {
      democrat: candidates.filter(d => d.party === 'DEM'),
      republican: candidates.filter(d => d.party === 'REP'),
    };

    let note;
    note = notesData.find(note => note.district == district);

    return { partyBallot, note };
  }

  render() {
    const { district } = this.props;
    const districtData = tagsData.find(d => d.district === district);

    const districtUrl = `https://www.texastribune.org/directory/districts/tx-house/${district}`;
    const repName = districtData.incumbent;
    const repUrl = districtData['directory_link'];

    const tag_2022_p = districtData['2022_p'];
    const party_2022_p = this.convertPartyName(districtData.party);
    const tag_2022_g = districtData['2022_g'];

    const tags_2022 = {
      primary: this.addArticles(tag_2022_p),
      general: this.addArticles(tag_2022_g),
    };

    const districtCount = districtData['combination_district_count'];
    const districtCountPct = Math.round((districtCount / 150) * 100 * 10) / 10;

    const summary_2024_primary = this.get2024PrimarySummary(
      districtData['2024_dp'],
      districtData['2024_rp']
    );

    const partyBallot = this.getMatch().partyBallot;
    const note = this.getMatch().note;

    const converter = PreactHTMLConverter();

    return (
      <div>
        <div class="district-info">
          <p>
            This location is in{' '}
            <a href={districtUrl}>
              <strong>Texas House {widont(`District ${district}`)}</strong>
            </a>
            .
          </p>

          <p>
            In 2022, the district’s representative{' '}
            <a href={repUrl}>{repName}</a> was elected in {tags_2022.primary}{' '}
            {party_2022_p} primary and {tags_2022.general} general election.
            That year, there were {districtCount} districts that had{' '}
            <strong class={tag_2022_p}>{tag_2022_p}</strong> primary and{' '}
            <strong class={tag_2022_g}>{tag_2022_g}</strong> general races,
            which make up about <strong>{districtCountPct}%</strong> of all
            districts.
          </p>

          <div class="see-results">
            <a
              href="https://apps.texastribune.org/features/2024/primary-election-results-2024#find-your-races"
              target="_blank"
              class="t-links-unset"
            >
              <div>{widont('SEE 2024 PRIMARY RESULTS FOR YOUR DISTRICT')}</div>
            </a>
          </div>

          {/* <p>In the upcoming primary election, {summary_2024_primary}.</p> */}
          {/* <p>
            In the upcoming primary election, the candidates in this district
            are:
          </p> */}
        </div>
        {/* <div class="seat__sections-wrapper">
          <div class="seat__races__wrapper">
            <h4 class="seat__section-header">2024 primary candidates</h4>
            <div class="seat__races">
              <PartyColumn
                partyName={'democrat'}
                partyBallot={partyBallot.democrat}
              />
              <PartyColumn
                partyName={'republican'}
                partyBallot={partyBallot.republican}
              />
            </div>

            {note != undefined && (
              <p class="note__text">{converter.convert(note.value)}</p>
            )}
          </div> 
        </div> */}
      </div>
    );
  }
}

export default DistrictViewer;
